<template>
  <div class="tf-order-bill-container">
    <div class="filter-card" id="filter-card">
      <el-form :inline="true" :model="filterForm" class="demo-form-inline">
        <!-- 客户名称 -->
        <el-form-item label="客户名称">
          <el-input
            v-model.trim="filterForm.clientName"
            placeholder="请输入客户名称"
            size="small"
            clearable
            style="width: 144px"
          ></el-input>
        </el-form-item>
        <!-- 客户省 -->
        <el-form-item label="客户省">
          <el-select
            v-model="filterForm.province"
            placeholder="请选择省"
            size="small"
            class="filter-narrow"
            clearable
            @change="provinceBtn"
          >
            <el-option
              v-for="(item, index) in provinceData"
              :key="index"
              :label="item.rname"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <!-- 客户市 -->
        <el-form-item label="客户市">
          <el-select
            v-model="filterForm.city"
            placeholder="请选择市"
            size="small"
            class="filter-narrow"
            clearable
            @change="cityBtn"
          >
            <el-option
              v-for="(item, index) in cityData"
              :key="index"
              :label="item.rname"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <!-- 客户区 -->
        <el-form-item label="客户区">
          <el-select
            v-model="filterForm.area"
            placeholder="请选择区"
            size="small"
            class="filter-narrow"
            clearable
            @change="areaBtn"
          >
            <el-option
              v-for="(item, index) in areaData"
              :key="index"
              :label="item.rname"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <!-- 订单创建时间 -->
        <el-form-item label="订单创建时间">
          <el-date-picker
            v-model="filterForm.createTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            clearable
          ></el-date-picker>
        </el-form-item>

        <!-- 订单完成时间 -->
        <el-form-item label="订单完成时间">
          <el-date-picker
            v-model="filterForm.finishTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            clearable
          ></el-date-picker>
        </el-form-item>

        <!-- 订单状态 -->
        <el-form-item label="订单状态">
          <el-select
            v-model="filterForm.orderStatus"
            placeholder="请选择订单状态"
            size="small"
            class="filter-narrow"
            clearable
          >
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in orderStatusOptions"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 合作医药公司 -->
        <el-form-item label="合作医药公司">
          <el-input
            v-model.trim="filterForm.medicineManagerName"
            placeholder="请输入合作医药公司"
            size="small"
            class="filter-narrow"
            clearable
          ></el-input>
        </el-form-item>

        <!-- 省区公司 -->
        <el-form-item label="省区公司">
          <el-input
            v-model.trim="filterForm.provinceManagerName"
            placeholder="请输入省区公司"
            size="small"
            class="filter-narrow"
            clearable
          >
          </el-input>
        </el-form-item>
        <!-- 地区公司 -->
        <el-form-item label="地区公司">
          <el-input
            v-model.trim="filterForm.cityManagerName"
            placeholder="请输入地区公司"
            size="small"
            class="filter-narrow"
            clearable
          >
          </el-input>
        </el-form-item>

        <!-- 订单编号 -->
        <el-form-item label="订单编号">
          <el-input
            v-model.trim="filterForm.orderCode"
            placeholder="请输入订单编号"
            size="small"
            clearable
          >
          </el-input>
        </el-form-item>
        <!-- 操作按钮 -->
        <el-form-item>
          <el-button type="primary" @click="handleSearch" size="small"
            >搜索</el-button
          >
          <el-button @click="handleReset" size="small">重置</el-button>
          <el-button type="success" @click="handleExport" size="small"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-card">
      <el-table :data="tableData" border v-loading="loading">
        <el-table-column prop="clientName" label="客户名称" width="150px">
          <template slot-scope="scope">
            <div
              @click="handleCopy(scope.row.clientName)"
              class="copy-order-code"
            >
              {{ scope.row.clientName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="provinceName"
          label="客户省"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="cityName"
          label="客户市"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="areaName"
          label="客户区"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="clientAddress"
          label="客户详细地址"
          width="150px"
        ></el-table-column>
        <el-table-column prop="provinceManagerName" label="省区" width="100px">
          <template slot-scope="scope">
            <div
              @click="handleCopy(scope.row.provinceManagerName)"
              class="copy-order-code"
            >
              {{ scope.row.provinceManagerName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="cityManagerName" label="地办" width="100px">
          <template slot-scope="scope">
            <div
              @click="handleCopy(scope.row.cityManagerName)"
              class="copy-order-code"
            >
              {{ scope.row.cityManagerName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsName"
          label="商品/服务名称"
          width="150px"
        ></el-table-column>
        <el-table-column
          prop="orderStartTime"
          label="订单创建时间"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="orderEndTime"
          label="订单完成时间"
          width="100px"
        ></el-table-column>
        <el-table-column prop="orderStatus" label="订单状态">
          <template slot-scope="scope">
            <div>
              {{ statusMap[scope.row.orderStatus] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="salePrice" label="礼包单价"></el-table-column>
        <el-table-column prop="saleNumber" label="礼包数量"></el-table-column>
        <el-table-column prop="saleTotalPrice" label="总金额"></el-table-column>
        <el-table-column
          prop="medicineManagerName"
          label="合作医药公司"
          width="150px"
        ></el-table-column>
        <el-table-column
          prop="medicinePrice"
          label="药品单价"
        ></el-table-column>
        <el-table-column
          prop="medicineNumber"
          label="药品数量"
        ></el-table-column>
        <el-table-column
          prop="afterSaleTotalAmount"
          label="售后总金额"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="medicineTotalPrice"
          label="合作医药公司收入"
          width="140px"
        ></el-table-column>
        <el-table-column
          prop="cityManagerName"
          label="地区公司名称"
          width="150px"
        ></el-table-column>
        <el-table-column
          prop="cityServicePrice"
          label="服务费"
        ></el-table-column>
        <el-table-column
          prop="provinceManagerName"
          label="省区公司名称"
          width="150px"
        ></el-table-column>
        <el-table-column
          prop="provinceServicePrice"
          label="服务费"
        ></el-table-column>
        <el-table-column
          prop="orderCode"
          label="订单编号"
          width="200px"
        >
          <template slot-scope="scope">
            <div @click="handleCopy(scope.row.orderCode)" class="copy-order-code">
              {{ scope.row.orderCode }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页器 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  queryAdaptionGoodsList,
  queryTFGoodsSalesExport,
} from "@/api/statistics";
import {
  regionProvince,
  regionCity,
  regionArea,
} from "@/api/merchantsettlement/index";
import lodash from "lodash";
import dayjs from "dayjs";
export default {
  name: "TfOrderBill",
  data() {
    return {
      // 筛选表单数据
      filterForm: {
        clientName: "",
        province: "",
        city: "",
        area: "",
        createTimeRange: [],
        finishTimeRange: [],
        orderStatus: "",
        medicineManagerName: "",
        cityManagerName: "",
        provinceManagerName: "",
        orderCode: "",
      },
      // 表格数据
      tableData: [],
      // 分页数据
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      //   订单状态：1.待付款,2.待发货, 3.配送中,4.资质待审核,5.交易取消, 6申请退款,7.已退款,8.已签收, 9.已完成, 00.不展示订单,11-订单待审核,10-待确款
      statusMap: {
        1: "待付款",
        2: "待发货",
        3: "配送中",
        4: "资质待审核",
        5: "交易取消",
        6: "申请退款",
        7: "已退款",
        8: "已签收",
        9: "已完成",
        // 00: "不展示订单",
        11: "订单待审核",
        10: "待确款",
      },
      orderStatusOptions: [
        { label: "待付款", value: "1" },
        { label: "待发货", value: "2" },
        { label: "配送中", value: "3" },
        // { label: "资质待审核", value: "4" },
        { label: "交易取消", value: "5" },
        // { label: "申请退款", value: "6" },
        // { label: "已退款", value: "7" },
        { label: "已签收", value: "8" },
        { label: "已完成", value: "9" },
        { label: "订单待审核", value: "11" },
        { label: "待确款", value: "10" },
      ],
      loading: false,
      provinceData: [],
      cityData: [],
      areaData: [],
    };
  },
  methods: {
    getProvince() {
      regionProvince().then((res) => {
        if (res.code === 0) {
          this.provinceData = res.data;
        }
      });
    },
    provinceBtn(item) {
      this.cityData = [];
      this.areaData = [];
      if (!item) {
        this.filterForm.city = "";
        this.filterForm.area = "";
      } else {
        regionCity(item).then((res) => {
          this.cityData = res.data;
          this.filterForm.city = "";
          this.filterForm.area = "";
        });
      }
    },
    cityBtn(item) {
      this.areaData = [];
      if (!item) {
        this.filterForm.area = "";
      } else {
        regionArea(item).then((res) => {
          this.filterForm.area = "";
          this.areaData = res.data;
        });
      }
    },
    areaBtn(item) {
      if (!item) {
        this.filterForm.area = "";
      }
    },
    // 复制文本到剪切板
    handleCopy(text) {
      if (!text) return;
      this.$copyText(text)
        .then(() => {
          this.$message.success("复制成功");
        })
        .catch(() => {
          this.$message.error("复制失败");
        });
    },
    // 搜索
    handleSearch() {
      this.loading = true;
      // 模拟搜索请求
      const filterForm = this.pendParams();
      queryAdaptionGoodsList({
        current: this.pagination.current,
        size: this.pagination.size,
        ...filterForm,
      }).then((res) => {
        this.tableData = res.records;
        this.pagination.total = res.total;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
      // 实际项目中这里会调用API获取数据
    },
    // 重置
    handleReset() {
      this.filterForm = {
        clientName: "",
        province: "",
        city: "",
        area: "",
        createTimeRange: [],
        finishTimeRange: [],
        orderStatus: "",
        medicineManagerName: "",
        cityManagerName: "",
        provinceManagerName: "",
        orderCode: "",
      };
      this.cityData = [];
      this.areaData = [];
      this.handleSearch();
    },
    pendParams() {
      const filterForm = lodash.cloneDeep(this.filterForm);
      // 将省市区id转为名称
      const provinceItem = this.provinceData.find(
        (item) => item.id === filterForm.province
      );
      const cityItem = this.cityData.find(
        (item) => item.id === filterForm.city
      );
      const areaItem = this.areaData.find(
        (item) => item.id === filterForm.area
      );
      filterForm.provinceName = provinceItem ? provinceItem.rname : "";
      filterForm.cityName = cityItem ? cityItem.rname : "";
      filterForm.areaName = areaItem ? areaItem.rname : "";
      delete filterForm.province;
      delete filterForm.city;
      delete filterForm.area;
      if (filterForm?.createTimeRange?.length > 0) {
        filterForm.orderStartTimeMin =
          dayjs(filterForm.createTimeRange[0]).format("YYYY-MM-DD") +
          " 00:00:00";
        filterForm.orderStartTimeMax =
          dayjs(filterForm.createTimeRange[1]).format("YYYY-MM-DD") +
          " 23:59:59";
      }
      if (filterForm?.finishTimeRange?.length > 0) {
        filterForm.orderEndTimeMin =
          dayjs(filterForm.finishTimeRange[0]).format("YYYY-MM-DD") +
          " 00:00:00";
        filterForm.orderEndTimeMax =
          dayjs(filterForm.finishTimeRange[1]).format("YYYY-MM-DD") +
          " 23:59:59";
      }
      delete filterForm.createTimeRange;
      delete filterForm.finishTimeRange;
      return filterForm;
    },
    // 导出
    handleExport() {
      // 实际项目中这里会调用导出API
      queryTFGoodsSalesExport({
        ...this.pendParams(),
      });
    },
    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.size = val;
      this.handleSearch();
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.handleSearch();
    },
  },
  mounted() {
    // 初始化加载数据
    this.handleSearch();
    this.getProvince();
    // 计算 filter-card 高度
    const filterCard = document.getElementById("filter-card");
    const filterCardHeight = filterCard.clientHeight;
    document.documentElement.style.setProperty(
      "--filter-card-height",
      `${filterCardHeight}px`
    );
  },
};
</script>

<style scoped lang="scss">
:root {
  --filter-card-height: 100px;
}
.tf-order-bill-container {
  height: calc(100vh - 140px);
  background: #fff;
}
.filter-card {
  padding: 20px 20px 0px 20px;
}
.table-card {
  padding: 0px 20px;
  height: calc(100% - var(--filter-card-height) - 60px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c0c4cc;
    border-radius: 5px;
    &:hover {
      background-color: #909399;
    }
  }
  &::-webkit-scrollbar-track {
    background-color: #f5f7fa;
  }
  ::v-deep .el-table__body-wrapper {
    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c0c4cc;
      border-radius: 5px;
      &:hover {
        background-color: #909399;
      }
    }
    &::-webkit-scrollbar-track {
      background-color: #f5f7fa;
    }
  }
}
.pagination-container {
  text-align: right;
  margin-top: 10px;
}
.copy-order-code{
  cursor: copy;
}
.filter-narrow {
  width: 144px;
}
</style>